function redirectToCountry(){
  let picker = document.getElementById("RedirectCountryPicker");
  let selectedOption = picker.options[picker.selectedIndex];
  let countryIso = selectedOption.getAttribute('country-iso');
  
  //create a cookie with the country code of the country the user selected
  var date = new Date();
  date.setTime(date.getTime()+(30*24*3600*1000));
  document.cookie = 'countryRedirect=' + countryIso + '; expires='+date.toUTCString() + '; path=/; domain=.savannahs.com';
  
  let url = selectedOption.value + window.location.pathname + window.location.search;
  window.location.href = url;
}
